import { createFeature, createReducer, on } from '@ngrx/store';
import { QuickApplicationActions } from './quick-application.actions';
import { QuickApplicationState } from './quick-application.models';

export const initialQuickApplicationState: QuickApplicationState = {
  formValue: null,
  lastUpdatedAt: null
};

const reducer = createReducer(
  initialQuickApplicationState,
  on(QuickApplicationActions.formUpdated, (state, { formValue }) => ({
    ...state,
    formValue,
    lastUpdatedAt: Date.now()
  })),
  on(QuickApplicationActions.cleared, () => initialQuickApplicationState)
);

export const quickApplicationFeature = createFeature({
  name: 'quickApplication',
  reducer
});
